module.exports = __webpack_public_path__ + "img/user0.a02eab57.png";